import { render, staticRenderFns } from "./BulkClaim.vue?vue&type=template&id=358658e3&scoped=true&"
import script from "./BulkClaim.vue?vue&type=script&lang=js&"
export * from "./BulkClaim.vue?vue&type=script&lang=js&"
import style0 from "./BulkClaim.vue?vue&type=style&index=0&id=358658e3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358658e3",
  null
  
)

export default component.exports